<div class="relative w-[100dvw] flex md:items-center justify-center items-center min-h-screen text-white p-6 md:px-4 bg-[radial-gradient(circle_at_50%_10%,_#1E1E1E,_#000000)]">
  <div class="w-full max-w-[1020px] md:p-1 transition-all duration-500">
    <!-- Текст -->
    <div class="space-y-4 text-base/[140%] sm:text-lg[118%] md:text-[20px]/[24px]">
      <p class="mb-0 md:mb-3">
				Выбор профессии… Одно из самых важных решений в жизни.
			</p>
      <p class="mb-0 md:mb-3">
				"Ты уже определился?" - спрашивают тебя.
			</p>
      <p class="mb-0 md:mb-3">
				Но как выбрать, если перед тобой целый парк профессий, в котором ты еще не бывал...
			</p>
      <p>Что делать в такой ситуации? Конечно же, только...</p>
    </div>

		<div class="progress static mt-20 max-w-9/10 w-140 h-30 m-auto"
		[class.flex]="showStartButton && tokenUpdated"
		[class.justify-center]="showStartButton && tokenUpdated">
    	<!-- Прогресс-бар -->

			@if (showStartButton && tokenUpdated) {
				<app-button class="mb-8 mt-auto mx-auto md:m-auto" (clicked)=" play()">
					Играть&nbsp;и&nbsp;узнать
				</app-button>
			} @else {
				<div class="w-75 max-w-full m-auto">
					<div class="font-bold text-xl sm:text-2xl md:text-[27px] text-center text-(--text-color-light)">
						{{ progress }}%...
					</div>
					<div class="w-full bg-white/30 rounded-full h-4 sm:h-5 md:h-[22px] overflow-hidden border border-2">
						<div
							class="h-full bg-(--main-color)  border border-2 border-black  rounded-full transition-all duration-300 ease-in-out"
							[style.width.%]="progress"
						></div>
					</div>
				</div>

				<!-- Подпись -->
				<div class="mt-6 px-8 py-4 rounded-md text-center font-(family-name:--default-font-family2) font-light text-xs sm:text-sm md:text-[20px]/8">
					Пожалуйста, подождите, идёт загрузка...
				</div>
			}
		</div>
  </div>
</div>
